<template>
    <div class="socialevents">
      <h2 class="card-title">Social Feeds</h2>
      <p class="description">
        Explore our collection of photos, videos, and event highlights
        showcasing life at Lagos Lawn Tennis Club
      </p>
  
      <div style="width: 100%; overflow-x: scroll;">
        <iframe src="https://www.juicer.io/api/feeds/lagoslawntennisclub-1895/iframe" frameborder="0" width="1000" height="1000" style="display:block;margin:0 auto;"></iframe>
      </div>
    </div>
</template>

<script setup>
import { onMounted } from "vue";
//import SocialFeedCard from "./CommonCard/SocialFeedCard.vue";

onMounted( async () => {
    if (!document.getElementById("elfsight-script")) {
      const script = document.createElement("script");
      script.id = "elfsight-script";
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  
});


// Array of card data

</script>

<style scoped lang="scss">
.socialevents {
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
}

.btn-active {
    background-color: #ED4E24;
    color: #fff;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border: 2px solid #ED4E24;
    border-radius: 60px;
    width: 103px;
}

.btn-not-active {
    background-color: #fff;
    border: 2px solid #9B9A9A;
    color: #9B9A9A;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border-radius: 60px;
    width: 103px;

}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
}

.cards {
    display: flex;
    justify-content: center;
    align-items: start;
    gap: 20px;
    margin-top: 5rem;
}
.card-title{
    font-size: 48px; 
    font-weight: 400;
}
@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .cards {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 5rem;
    }
    .card-title{
        font-size: 35px; 
    }
}
</style>
